import {
  FestivalListRequest,
  FestivalListResponse,
  SaveFestivalPayload,
  UpdateFestivalPayload,
  uploadFilesProps,
} from '../../../types/Settings/FestivalManagement/FestivalManagementType'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, festivalUploadApiConfig } from '../apiList'

const festivalUpload = async (data: uploadFilesProps): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.uploadFestival,
    method: AllowedHttpMethods.post,
    data: data.file,
    params: {
      folderName: data.folderName,
    },
    additionalHeaders: {
      'Content-Type': 'multipart/form-data',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllFestivals = async ({
  startIndex,
  endIndex,
}: FestivalListRequest): Promise<FestivalListResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.getAllFestivals,
    method: AllowedHttpMethods.get,
    params: {
      startIndex,
      endIndex,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const saveFestival = async (payload: SaveFestivalPayload): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.saveFestival,
    method: AllowedHttpMethods.post,
    data: payload,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const updateFestival = async (
  payload: UpdateFestivalPayload,
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.updateFestival,
    method: AllowedHttpMethods.put,
    data: payload,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteFestival = async (festivalId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.deleteFestival,
    method: AllowedHttpMethods.delete,
    params: {
      festivalId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const checkFestivalNameExist = async (
  festivalName: string,
): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: festivalUploadApiConfig.checkFestivalNameExist,
    method: AllowedHttpMethods.get,
    params: {
      festivalName,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

export const FestivalUploadApi = {
  uploadFestival: festivalUpload,
  getAllFestivals,
  saveFestival,
  updateFestival,
  deleteFestival,
  checkFestivalNameExist,
}
